<span class="badge" [ngClass]="'badge-' + (item ? existColor : notExistColor)">
      {{ item ? existText : notExistText }}
</span>
